import moment from "moment";
import React, { useEffect, useState } from "react";
import * as downloadFile from "js-file-download";

import RPMBillingForm from "./RPMBillingForm";
import LoadingModal from "components/common/loading/LoadingModal";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";

import { formatDateTime } from "utils/date";
import { showErrorToast, showSuccessToast } from "utils/toast";
import { downloadRpmBillingHistory } from "app/services/patient/rpmPatient";

// Import CSS
import "../BillingModal/index.css";
import { Formik } from "formik";
import SubmitButton from "components/Button/SubmitButton";
import { Button } from "@mui/material";
import { rpmBillingValidationSchema } from "schemas/rpmBillingValidationSchema";
import { filterNonUCHAccounts } from "utils/account.util";

const RPMBillingModal = (props) => {
  const { role, open, onClose, accounts } = props;
  const [isDownloading, setIsDownloading] = useState(false);
  const filteredAccounts = filterNonUCHAccounts(accounts);

  const [payload, setPayload] = useState({
    account: "",
    // billingDate: formatDateTime(moment().subtract(1, "month"), "MMMM yyyy"), // Need to use this from next month.
    billingDate: formatDateTime(moment(), "MMMM yyyy"),
  });

  useEffect(() => {
    setPayload((prevPayload) => ({
      ...prevPayload,
      account:
        filteredAccounts?.length === 1 ? filteredAccounts?.[0]?.name : "",
    }));
  }, [filteredAccounts, role]);

  const onInputChange = (name, value) => {
    setPayload((prevPayload) => ({
      ...prevPayload,
      [name]: value,
    }));
  };

  const handleDownload = async () => {
    try {
      setIsDownloading(true);

      const { billingDate, account } = payload;
      const response = await downloadRpmBillingHistory(payload);

      if (response.error) {
        showErrorToast(response.message);
      } else {
        const fileName = `${account}- RPM billing invoice - ${billingDate}.xlsx`;

        await downloadFile(response.data, fileName);

        showSuccessToast("Downloaded Successfully");

        onClose();
      }
    } catch (error) {
      showErrorToast(error.message);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <ModalWrapper
      title="RPM Billing Invoice"
      show={open}
      showCloseIcon={true}
      headerStyle={{ padding: "0.25rem 1.5rem" }}
      onClose={(_event, reason) => {
        if (reason && reason === "backdropClick") return;
        onClose();
      }}
    >
      <Formik
        initialValues={{
          ...payload,
        }}
        validationSchema={rpmBillingValidationSchema}
        onSubmit={handleDownload}
        initialErrors={{}}
        enableReinitialize
      >
        {(formikProps) => (
          <>
            <RPMBillingForm
              role={role}
              accounts={filteredAccounts}
              formikProps={formikProps}
              payload={payload}
              onInputChange={onInputChange}
            />

            <div className="buttons-wrapper" style={{ marginTop: 20 }}>
              <Button
                variant="outlined"
                color="secondary"
                disabled={formikProps?.isSubmitting}
                onClick={() => {
                  formikProps?.resetForm();
                  onClose();
                }}
              >
                Cancel
              </Button>
              <SubmitButton
                handleClick={formikProps?.handleSubmit}
                buttonText="Download"
              />
            </div>
          </>
        )}
      </Formik>

      {isDownloading && (
        <LoadingModal open={isDownloading} loadingText="Downloading..." />
      )}
    </ModalWrapper>
  );
};

export default RPMBillingModal;
